import { Box } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import CreateNewsLetters from "./CreateNewsLetters";
import NewsLettersList from "./NewsLettersList";
import { NewsLettersModel } from "model/screensModels/NewsLettersModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { msgTypes } from "constants/msgTypes";
import { NewsLettersService } from "services/menu/newsLettersService/NewsLettersService";
import ApiUrl from "services/shared/ApiUrl";
import { DataNotFound } from "screens/sharedScreens/dataNotFound/DataNotFound";
import DOMPurify from 'dompurify';

export default function NewsLetters() {
  const [value, setValue] = React.useState(new NewsLettersModel());
  const [flag, setFlag] = useState(false);
  const [updateValue, setUpdateValue] = React.useState(new NewsLettersModel());
  const [recentNewsletter, setRecentNewsletter] = useState(new NewsLettersModel());
    const [isEditMode, setIsEditMode] = useState(false);
  
  //Prepare request body to get Newsletter list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;
    return requestBody;
  }

  //Get Newsletter list
  const loadRecentNewsletter = async () => {
    const requestBody = prepareRequest();
    const res = await NewsLettersService.getNewsLettersList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res?.data !== '') {
        setRecentNewsletter(res?.data?.tbody[0]);
      }else{
        setRecentNewsletter(new NewsLettersModel());
      }
    }
  }

  const getUpdateRecordValue = (newsLettersModel: NewsLettersModel) => {
    setIsEditMode(true);
    setUpdateValue(newsLettersModel);
  }

  const addNewsLetters = () => {
    setFlag(true)
    setIsEditMode(false); // Reset edit mode
    setUpdateValue(new NewsLettersModel());
  }

  const RecentNewsletter = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently Newsletter </h5>
        {recentNewsletter.newsLetterId!=='' ? (
        <div>
          <div className='container'>
            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Title : </h5>
              </div>
              <div className='col-lg-8'>
                {recentNewsletter.title}
              </div>
            </div>

            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Description : </h5>
              </div>
              <div className='col-lg-8'
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(recentNewsletter.description || "") }}>
              </div>
            </div>

            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Link : </h5>
              </div>
              <div className='col-lg-8 word-break-recent'>
                <span className="link-text">
    {recentNewsletter.link}
  </span>
              </div>
            </div>

            <div className='row recent-row'>
              <div className='col-lg-4 '>
                <h5>Attachment : </h5>
              </div>
              <div className='col-lg-8'>
                <img src={ApiUrl.fileBaseUrl + recentNewsletter.image} className="recentdded-section"></img>
              </div>
            </div>
          </div>
        </div>
      ) :(
          <>
          <DataNotFound message="There is no Newsletters"/>
          </>
         )}
      </>
    )
  }

  return (
    <Box sx={{ width: "100%" }} className="container container-h-full">
      <Box>
  
                
      <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Newsletters List </h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Newsletters' : 'Add Newsletterss'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addNewsLetters}>  Add Newsletters</button>}
          </div>
      </Box>

      
        {!flag ? (
          <div className='sub-content-sec recently-blog'>
            <NewsLettersList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentNewsletter={loadRecentNewsletter}></NewsLettersList>
          </div>
        ) : (
            <div className='row'>
              <div className='col-lg-5 work'>
                <div className='sub-content-sec recently-blog'>
                  <RecentNewsletter />
                </div>
              </div>
              <div className='col-lg-7'>
                <div className='sub-content-sec recently-blog'>
                  <CreateNewsLetters setFlag={setFlag} updateRecord={updateValue} loadRecentNewsletter={loadRecentNewsletter}></CreateNewsLetters>
                </div>
              </div>
            </div>
        )}
     
    </Box>
  );
}
